import { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { Container } from '@components/styled'
import randomNumberBetween from '@utils/randomNumberBetween'
import { windowLoadWithTimetout } from '@utils/timeout'

const Grid = styled(Container)`
  display: grid;
  grid-gap: 2.4rem;
  max-width: 158rem;

  ${up('lg')} {
    grid-template-columns: repeat(2, 1fr);
  }
`

const GridItem = styled.img`
  object-fit: cover;
  contain: layout;
  transform: translateY(15%);
  opacity: 0;
`

interface Image {
  src: string
  alt?: string
}

interface ImagesGridProps {
  images: Image[]
}

const ImagesGrid: React.FC<ImagesGridProps> = ({ images }) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)

    windowLoadWithTimetout(() => {
      const container = containerRef.current as HTMLDivElement
      const items = container.querySelectorAll('.js-image')

      items.forEach((item, i) => {
        ScrollTrigger.create({
          trigger: item as Element,
          start: '30% bottom',
          once: true,
          onEnter: (self) => {
            const delay = i === 0 ? 0 : randomNumberBetween(0, 0.4)

            gsap.to(self.trigger?.firstChild as gsap.TweenTarget, {
              y: 0,
              ease: 'expo.out',
              delay,
              duration: 1.6,
            })

            gsap.to(self.trigger?.firstChild as gsap.TweenTarget, {
              opacity: 1,
              ease: 'power3.out',
              delay,
              duration: 0.8,
            })
          },
        })
      })
    })
  }, [])

  return (
    <Grid ref={containerRef}>
      {images.map(({ src, alt }) => (
        <div key={src + alt} className="js-image">
          <GridItem src={src} alt={alt} loading="lazy" />
        </div>
      ))}
    </Grid>
  )
}

export default ImagesGrid
